import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { SEO } from '../../components/Seo';
import { Kfh_ContentPageUmbracoType, Kfh_ContentServicePageType } from '../../types/graphqlTypes';
import { ComponentRenderer } from '../../components/componentRenderer/ComponentRenderer';
import { PageHeader } from '../../components/pageHeader/PageHeader';
import { LinkedPages } from '../../components/LinkedPages';

interface ServicePageProps {
  page: Kfh_ContentPageUmbracoType;
}

const ServicePage = ({ data }: PageProps<ServicePageProps>) => {
  const { layout, linkedPages } = data.page;
  const { pageHeader, regions } = layout as unknown as Kfh_ContentServicePageType;

  // Regions
  const wideTopRegion = regions.filter((region) => region.regionType === 'TopWide')[0];
  const narrowRegion = regions.filter((region) => region.regionType === 'Narrow')[0];
  const wideRegion = regions.filter((region) => region.regionType === 'Wide')[0];

  return (
    <>
      {/* Page header / hero */}

      {pageHeader && <PageHeader pageHeader={pageHeader} />}

      {/* Regions and Components */}
      {/* Wide top region */}
      <ComponentRenderer components={wideTopRegion?.components} width="wide" />

      {/* Narrow top region */}
      <ComponentRenderer components={narrowRegion?.components} width="narrow" />

      {/* Wide bottom region */}
      <ComponentRenderer components={wideRegion?.components} width="wide" />

      {/* Related pages */}
      <LinkedPages title="More property services from KFH" linkedPages={linkedPages} pageType="Service" />
    </>
  );
};

export default ServicePage;

export const Head = ({ data }: HeadProps<ServicePageProps>) => {
  const { seoSettings, feed } = data.page;
  return (
    <SEO
      data={seoSettings}
      image={feed?.featuredImage?.localFile?.resize?.src ? feed.featuredImage.localFile.resize.src : undefined}
    />
  );
};

export const pageQuery = graphql`
  query ServicePageQuery($id: String!) {
    page: kfhContentPageUmbracoType(id: { eq: $id }) {
      pageName
      seoSettings {
        ...SEO
      }
      feed {
        featuredImage {
          ...PageSocialImage
        }
      }
      classification {
        audiences
        services
      }
      layout {
        ... on KFH_ContentServicePageType {
          pageHeader {
            ...PageHeader
          }
          regions {
            ...ComponentRegions
          }
        }
      }
      linkedPages {
        pageName
        relativeUrl
        feed {
          shortDescription
          shortTitle
          featuredImage {
            localFile {
              gatsbyImage(
                width: 520
                height: 544
                layout: CONSTRAINED
                cropFocus: CENTER
                placeholder: NONE
                quality: 80
                backgroundColor: "#F5F5F5"
              )
            }
          }
        }
      }
    }
  }
`;
